// src/main.js
import '../scss/main.scss'; // Import your main Sass file
// ... rest of your JavaScript code

jQuery('#responsive_title').fitText(1.2, { minFontSize: '48', maxFontSize: '54' }),
jQuery('#responsive_description').fitText(1.2, { minFontSize: '18', maxFontSize: '24' });

jQuery(function($) {
  // Bootstrap menu magic
  if($(window).width() < 767) {
     $(".dropdown-toggle").attr('data-hover', 'dropdown');
   $('.dropdown').on('show.bs.dropdown', function () {
   $(this).siblings('.open').removeClass('open').find('a.dropdown-toggle').attr('data-hover', 'dropdown');
   $(this).find('a.dropdown-toggle').removeAttr('data-hover');
     });
  }
});

// Display commentform on #respond click (Vanilla JavaScript)
document.addEventListener('DOMContentLoaded', function() {
    const respondDiv = document.getElementById('respond');
    const commentForm = document.getElementById('commentform');

    if (respondDiv && commentForm) {
        commentForm.style.display = 'none'; // Initially hide the comment form

        respondDiv.addEventListener('click', function(event) {
            if (commentForm.style.display === 'none') {
                commentForm.style.display = 'block'; // Show the comment form
            } else {
                commentForm.style.display = 'none'; // Hide the comment form
            }
        });
    }
	// Add hover effect
        respondDiv.addEventListener('mouseover', function() {
            respondDiv.style.cursor = 'pointer';
            respondDiv.classList.add('respond-active');
        });

        respondDiv.addEventListener('mouseout', function() {
            respondDiv.classList.remove('respond-active');
            respondDiv.style.cursor = 'default';
        });
});

